import { DialogService, GridAction } from '@eforall/dashboard';
import { SessionTopicSpecialist } from '../../../../../../interfaces';
import { SpecialistSignUpViewerDialog } from '../../../specialist-sign-up';
import { AccSessionViewerDialogDataService } from '../../acc-session-viewer-dialog-data.service';

export function getActions(pageService: AccSessionViewerDialogDataService, dialogService: DialogService) {

	const actions: GridAction<SessionTopicSpecialist & { updatedUTC: number }>[] = [
		{
			iconClass: 'fa-regular fa-check',
			label: 'Assign Specialist',
			isEnabled: rows => !!rows.length && !rows[0]!.assignedEventId && rows[0]!.volunteerSignupSpecialistStatus !== 'Assigned',
			execute: async rows => {
				await pageService.assignSpecialist(rows[0]!.volunteerSignupSpecialistTopicId, rows[0]!.canAttend === 'Conflict');
			}
		},
		{
			iconClass: 'fa-regular fa-pencil',
			label: 'Mark as Pending',
			isEnabled: rows => !!rows.length && rows[0]!.volunteerSignupSpecialistStatus !== 'Pending',
			execute: async rows => {
				await pageService.changeToStatus(rows[0]!.volunteerSignupSpecialistTopicId, 'Pending');
			}
		},
		{
			iconClass: 'fa-regular fa-clock',
			label: 'Mark as Waitlisted',
			isEnabled: rows => !!rows.length && rows[0]!.volunteerSignupSpecialistStatus !== 'Waitlisted',
			execute: async rows => {
				await pageService.changeToStatus(rows[0]!.volunteerSignupSpecialistTopicId, 'Waitlisted');

			}
		},
		{
			iconClass: 'fa-regular fa-times',
			label: 'Remove Specialist',
			isEnabled: rows => !!rows.length && !!rows[0]!.assignedEventId && rows[0]!.volunteerSignupSpecialistStatus == 'Assigned',
			execute: async rows => {
				await pageService.changeToStatus(rows[0]!.volunteerSignupSpecialistTopicId, 'Removed');

			}
		},
		{
			iconClass: 'fa-regular fa-eye',
			label: 'View Specialist Sign-ups',
			isEnabled: rows => !!rows.length,
			execute: async rows => {
				await dialogService.showCustom(SpecialistSignUpViewerDialog, {
					data: {
						volunteerSignupSpecialistId: rows[0]!.volunteerSignupSpecialistId,
					}
				}, 700, 600);
				await pageService.baseAreaService()?.reloadData();
			}
		},
	];

	return actions;
}